module.exports = __webpack_public_path__ + "img/專屬模型.bba45f02.svg";